module.exports = __webpack_public_path__ + "img/Group 15.648b4311.svg";